import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';
import {
  CartDefaultProps,
  CartPropTypes,
} from '@/common/proptypes/Cart/Cart.proptypes';

export const AsideDefaultProps = {
  ...BaseDefaultProps,
  cart: { ...CartDefaultProps },
  isUpdated: false,
  onScanBarCode: () => {},
  refetchCart: () => {},
};

export const AsidePropTypes = {
  ...BasePropTypes,
  cart: PropTypes.shape({ ...CartPropTypes }),
  isUpdated: PropTypes.bool,
  onScanBarCode: PropTypes.func,
  refetchCart: PropTypes.func,
};
